import React from 'react';
import { Td } from 'reactable';
import { Link } from 'react-router';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/* the following two functions are helpers from the original Reactable code...*/
function toArray(obj) {
  var ret = [];
  for (var attr in obj) {
    ret[attr] = obj;
  }
  return ret;
}

var internalProps = {
  hideTableHeader: true,
  column: true,
  columns: true,
  sortable: true,
  filterable: true,
  filtering: true,
  onFilter: true,
  filterPlaceholder: true,
  filterClassName: true,
  currentFilter: true,
  sort: true,
  sortBy: true,
  sortableColumns: true,
  onSort: true,
  defaultSort: true,
  defaultSortDescending: true,
  itemsPerPage: true,
  filterBy: true,
  hideFilterInput: true,
  noDataText: true,
  currentPage: true,
  onPageChange: true,
  previousPageLabel: true,
  nextPageLabel: true,
  pageButtonLimit: true,
  childNode: true,
  data: true,
  children: true,
  tagColorDict: true,
  onTagClick: true,
  thematicDict: true,
  defaultColor: true
};

function filterPropsFrom(baseProps) {
  baseProps = baseProps || {};
  var props = {};
  for (var key in baseProps) {
    if (!(key in internalProps)) {
      props[key] = baseProps[key];
    }
  }

  return props;
}

export class Tr extends React.Component {
  findTopicByAbbreviation(abbreviation) {
    const topic = Object.values(this.props.thematicDict)
      .find(item => {
        return item.abbreviation === abbreviation;
      });
    return topic;
  }

  getThematicColor(abbreviation) {
    const topic = this.findTopicByAbbreviation(abbreviation);
    return topic && topic.colorCode ? topic.colorCode : this.props.defaultColor;
  }

  getFullTopicName(abbreviation) {
    const topic = this.findTopicByAbbreviation(
      abbreviation,
      this.props.thematicDict
    );
    return topic && topic.fullTopicName ? topic.fullTopicName : ' ';
  }

  render() {
    var children = toArray(React.Children.children(this.props.children));
    // First element in the row, should be the country name.
    // This information is needed for the modal so we need to pass it seperately
    let countryName = null;

    if (
      this.props.data &&
      this.props.columns &&
      typeof this.props.columns.map === 'function'
    ) {

      if (typeof children.concat === 'undefined') {
        console.log(children);
      }

      children = children.concat(
        this.props.columns.map(
          function({ props = {}, ...column }, i) {
            if (this.props.data.hasOwnProperty(column.key)) {
              var valueBlob = this.props.data[column.key];
              var value = valueBlob.value;

              if (
                typeof value !== 'undefined' &&
                value !== null &&
                value.__reactableMeta === true
              ) {
                props = value.props;
                value = value.value;
              }

              if (i === 0) {
                countryName = value;
                const countryCode = this.props.data.countryCode;
                const link = '/international-assistance/' + countryCode;

                return (
                  <Td column={column} key={column.key} {...props}>
                    <Link activeClassName="active" to={link}>
                      {countryName}
                    </Link>
                  </Td>
                );
              }

              const thematicColor = this.getThematicColor(value);
              let tableTag = (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip">
                      {this.getFullTopicName(value, this.props.thematicDict)}
                    </Tooltip>
                  }
                >
                  <span
                    className="tag-table-tag"
                    style={{ backgroundColor: thematicColor }}
                    onClick={this.props.onTagClick.bind(
                      null,
                      countryName,
                      valueBlob
                    )}
                  >
                    {value}
                  </span>
                </OverlayTrigger>
              );

              if (value === '') {
                tableTag = null;
              } /* not elegant but readable */
              return (
                <Td column={column} key={column.key} {...props}>
                  {tableTag}
                </Td>
              );
            } else {
              return <Td column={column} key={column.key} />;
            }
          }.bind(this)
        )
      );
    }

    // Manually transfer props
    var props = filterPropsFrom(this.props);

    return React.DOM.tr(props, children);
  }
}

Tr.childNode = Td;
Tr.dataType = 'object';



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/Tagtable-tr.js